/**
 * Build the auth-app URL to bounce an unauthenticated user to, carrying where
 * they were as `return_to`. The auth app re-validates `return_to` (same-origin
 * or allowlisted host) before honouring it, so this side only has to encode it.
 */
export function buildLoginUrl(authOrigin: string, returnTo: string): string {
	const url = new URL('/', authOrigin);
	url.searchParams.set('return_to', returnTo);
	return url.toString();
}
